import { takeEvery, all, call, put, select } from 'redux-saga/effects'
import { buildGETUrl } from '../../utilities/buildGETUrl'
import { DELETE_VIDEOLISTS, loading, loadVideolists } from '../../store/ContentVideolists/actions'
import { showAlertError } from '../../store/Alert/actions'
import axios from 'axios'
import { clearPlaylist, PLAY_TRACK, setPlaylist } from '../../store/AudioPlayer/actions'

export default function* () {
    yield takeEvery(PLAY_TRACK, worker)
}

function* worker({ payload }) {

    const { from } = payload;



    if (from) {

        if (from === 'current') {
            const playlist = yield select(state => state.playlists.allPlaylists.find(
                (cur) => cur.id === state.playlists.selected[0]
            ));
            console.log({ list: playlist.songs });

            yield put(setPlaylist({
                on: true,
                list: playlist.songs,
                loadMoreParams: null
            }))
        }

        if (from === 'public') {


            const list = yield select(state => state.public_playlists.selected[0] ?
                state.public_playlists.assocPublicTracks :
                state.public_playlists.allPublicTracks);

            console.log({ list });


            yield put(setPlaylist({
                on: true,
                list: Array.from(list.values()),
                loadMoreParams: null
            }))
        }
    } else {
        yield put(clearPlaylist())
    }

}

function fetchDeleteVideolists(videolistId) {
    return axios.get(`/videolist/delete?id=${videolistId}`)
        .then(response => response.data)
}